<div
[style.BackgroundColor]='corFundo'
[style.Color]='corTexto'
[style.Padding]="'4px 16px'"
[style.BorderRadius]="'8px'"
[style.display]="'inline-block'"
>
<i *ngIf="icone" class="{{ icone }}" style='text-align: center;'  [style.opacity]="'0.95'" [style.display]="'inline-block'"></i>
<span  *ngIf="icone"  [style.PaddingLeft]="'8px'"></span>
<span>{{ estadoTexto }}</span> 

</div>